import CommonIcon from '@/components/common-icon';
export default {
  components: {
    CommonIcon
  },
  methods: {
    showTitle(item) {
      return item.meta.title;
    },
    showChildren(item) {
      return item.children && (item.children.length > 1 || (item.meta && item.meta.showAlways));
    },
    getNameOrHref(item, children0) {
      let name = item.href ? `isTurnByHref_${item.href}` : (children0 ? item.children[0].name : item.name);
      if (name.indexOf('_') === 0) {
        return name.substr(1);
      }
      return name;
    }
  }
};
